module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAkCAYAAACqqEt1AAABSUlEQVQ4T3VTS04CQRSsckFi3OjKQ3gLvoIgEMNWFBX8i4piXBDDCq7AvbyBoKAwOGpMXPjMTPfAODRvNemaevXqVTfXHh5Dqz/LTYGUAQGBTj9kNxi+77YgUhf3kHCLbDN89zQCsKJOJmUxUu+K0wLe3/qbkVsHmC1Gb3qzDBKM1nruKMFirNYTpeChqjNj189mjfiVAqYszYhfvpgZiaoGHAnPjgBMVPtmxvrFPOB8YGYkzwbax3+LTJ6+Kud+HgGmHMA3kMdj6uTNrLFxPA84GgYYejnpwyCgY09XhgJyOhWd3AhmKiOzj0zZMlwGgJkDS/yLnfjY3HcYQesAs3tjHZmy70XCbGnsuyXOdKoBc6V380pyu3OA/I5t9pEv2uZW+eKHfgb6fShti1vbny2B1P3BEmyzUJDQ7+JXk4KymyTRWfheavwBDnORgkKfSOwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/dzy/assets/img/spanIMG.png
// module id = SIu8
// module chunks = 43